<template>
  <w-sliding-popup ref="slidingPopup" title="로디드 클래스 상세정보" width="650px" @close="closePopup">
    <div slot="content">
        <el-row v-if="isShowDownload" type="flex" class="title-bar mr-b20" justify="space-between">
          <div class="title-h4 tit">{{formInfoTitle}}</div>
        </el-row>
        <div class="list form-list mr-b20">
          <el-form ref="classInfoForm" :model="formData" label-width="100px">
            <el-form-item label="타입">
              {{this.classInfoParams.typeText}}
            </el-form-item>
            <el-form-item v-if="this.classInfoParams.classType === 'classDown'" label="클래스 이름">
              {{this.classInfoParams.name}}
            </el-form-item>
            <el-form-item v-else label="슈퍼 클래스 이름">
              {{this.classInfoParams.superClass}}
            </el-form-item>
          </el-form>
        </div>
        <el-row type="flex" class="title-bar" justify="end">
          <el-button class="mr-r4" :disabled="isClassDown" @click="detailInfoDown('classDown')">클래스 다운로드</el-button>
          <el-button :disabled="isjarDown" @click="detailInfoDown('jarDown')">JAR 다운로드</el-button>
        </el-row>
        <el-input readonly type="textarea" v-model="classDescContent" :rows="34"></el-input>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import ApmConfigAPI from '@/api/config/apm/apm-info';

export default {
  name: 'WClassDetailInfoPopup',
  props: {
    classInfoParams: {
      type: Object,
    },
  },
  data() {
    return {
      formData: {},
      formInfoTitle: '',
      classDescContent: '',
      isClassDown: false,
      isjarDown: false,
      isShowDownload: true,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    classInfoParams: {
      handler() {
        if (Object.entries(this.classInfoParams).length > 0) {
          this.isjarDown = this.classInfoParams.ablejarDown;
          this.isClassDown = this.classInfoParams.ableClassDown;
          this.isShowDownload = this.classInfoParams.isShowDownload;
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.classInfoParams.classType === 'classDown') {
        params.className = this.classInfoParams.name;
      } else {
        params.className = this.classInfoParams.superClass;
      }
      if (params.className.length > 0) {
        const splitClassName = params.className.split('.');
        this.formInfoTitle = splitClassName[splitClassName.length - 1];
      }
      ApmConfigAPI.getClassDescription(params).then((response) => {
        if (response.data.success) {
          this.classDescContent = response.data.data.class;
        }
      });
    },
    detailInfoDown(classType) {
      const params = {
        objIdStr: this.selectedNode.obj.objId,
      };
      if (classType === 'classDown') {
        params.downType = classType;
        params.fileName = this.classInfoParams.name;
      } else {
        params.downType = classType;
        params.fileName = this.classInfoParams.resource;
      }
      ApmConfigAPI.checkClassJarDown(params).then((response) => {
        if (response.data.success) {
          ApmConfigAPI.downloadLoadedClassInfo(params);
        } else {
          this.$message('파일 다운로드에 실패하였습니다.');
        }
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/config/node/apm/loadedclass/popup/ClassDetailInfoPopup.vue